const APPLE_SCRIPT_SRC =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

let scriptPromise = null;

function waitForAppleAuth(timeoutMs = 8000) {
  return new Promise((resolve, reject) => {
    if (window.AppleID?.auth) {
      resolve();
      return;
    }
    const started = Date.now();
    const tick = () => {
      if (window.AppleID?.auth) {
        resolve();
        return;
      }
      if (Date.now() - started >= timeoutMs) {
        reject(new Error('Falha ao carregar Apple ID.'));
        return;
      }
      window.setTimeout(tick, 50);
    };
    tick();
  });
}

export function loadAppleSignInScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Apple Sign In só está disponível no navegador.'));
  }
  if (window.AppleID?.auth) {
    return Promise.resolve();
  }
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${APPLE_SCRIPT_SRC}"]`);
      if (existing) {
        if (existing.getAttribute('data-load-error') === '1') {
          reject(new Error('Falha ao carregar Apple ID.'));
          return;
        }
        waitForAppleAuth()
          .then(resolve)
          .catch(reject);
        return;
      }
      const script = document.createElement('script');
      script.src = APPLE_SCRIPT_SRC;
      script.async = true;
      script.onload = () => {
        waitForAppleAuth().then(resolve).catch(reject);
      };
      script.onerror = () => {
        script.setAttribute('data-load-error', '1');
        scriptPromise = null;
        reject(new Error('Falha ao carregar Apple ID.'));
      };
      document.body.appendChild(script);
    });
  }
  return scriptPromise;
}

function randomOAuthValue() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export async function signInWithAppleWeb({ clientId, redirectURI }) {
  await loadAppleSignInScript();
  if (!window.AppleID?.auth) {
    throw new Error('Apple Sign In indisponível neste navegador.');
  }
  window.AppleID.auth.init({
    clientId,
    scope: 'name email',
    redirectURI,
    state: randomOAuthValue(),
    nonce: randomOAuthValue(),
    usePopup: true,
  });
  return window.AppleID.auth.signIn();
}
